import React from "react";
import { Spinner } from "@storyofams/react-ui";
import hoistNonReactStatics from "hoist-non-react-statics";

import { useQuery } from "react-query";
import { useShopify } from "../context";
import { getDisplayName } from "../lib/getDisplayName";
import { shopifySdk } from "./shopify/client";

const removeHiddenVariants = (prod) => {
  const filteredVariants = prod?.variants?.edges?.filter(({ node }) => {
    const metafieldNode = node?.metafields[0];
    if (metafieldNode?.key === "hide") {
      return metafieldNode?.value !== "true";
    }
    return node?.value !== "true";
  });
  return { ...prod, variants: { ...prod.variants, edges: filteredVariants } };
};

export function withB2B(Component: any) {
  const AuthComponent = ({ story, product }) => {
    const { customerCompanyId, apiToken, isB2B } = useShopify();
    const { data: b2bProduct, isLoading } = useQuery(
      [apiToken, customerCompanyId, product?.handle],
      async () => {
        const { productByHandle } = await shopifySdk.productByHandleWithContext(
          {
            handle: product.handle,
            buyer: {
              companyLocationId: customerCompanyId,
              customerAccessToken: apiToken,
            },
          }
        );
        return removeHiddenVariants(productByHandle);
      },
      {
        enabled: !!customerCompanyId && !!apiToken,
        refetchOnWindowFocus: false,
      }
    );
    if (customerCompanyId && isB2B) {
      return (
        <>
          {isLoading ? (
            <Spinner minHeight="200px" color="greenish" />
          ) : (
            <Component story={story} product={b2bProduct} />
          )}
        </>
      );
    }

    return <Component product={product} story={story} />;
  };

  hoistNonReactStatics(AuthComponent, Component);

  AuthComponent.displayName = `withAuth(${getDisplayName(Component)})`;

  return AuthComponent;
}
